<template>
  <div id="app">
    <ShopifyIframe v-if="currentRouteName.includes('/shopify-iframe')" />
    <Shopify v-else-if="currentRouteName.includes('/shopify')" />
    <Checkout v-else />
  </div>
</template>

<script>
import Shopify from '@/views/Checkout/Shopify/Checkout.vue'
import ShopifyIframe from '@/views/Checkout/Shopify/CheckoutIframe.vue'
import Checkout from '@/views/Checkout/Checkout.vue'

export default {
  name: 'App',
  components: {
    Checkout,
    Shopify,
    ShopifyIframe,
  },
  computed: {
    currentRouteName() {
      return this.$route.path
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/theme/index.scss';

:not.force-status-border {
  .am-input.error input {
    border: 1px solid $error !important;
    &:hover {
      border: 1px solid $error !important;
    }
    &:focus {
      border: 1px solid $error !important;
    }
  }
  .am-input.warning input {
    border: 1px solid $warning !important;
    &:hover {
      border: 1px solid $warning !important;
    }
    &:focus {
      border: 1px solid $warning !important;
    }
  }
  .am-input.success input {
    border: 1px solid $success !important;
    &:hover {
      border: 1px solid $success !important;
    }
    &:focus {
      border: 1px solid $success !important;
    }
  }
}
</style>
